export const audiencePathResources = {
    contacts: "contacts",
    segments: "segments",
} as const;
